export const FILE_TYPES = ["image/jpeg", "image/png"];
export const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB

export const validateFile = (file) => {
  if (!file) return "No file selected.";
  if (!FILE_TYPES.includes(file.type)) return "The selected file format is not supported.";
  if (file.size > MAX_FILE_SIZE) return "File size too large. Max 1MB.";
  return "";
};

export const handleFileUploadUtil = (event, setFormError, setUploadedFile, setImagePreview, setIsFromCamera) => {
  const file = event.target.files[0];
  const error = validateFile(file);

  if (error) {
    setFormError(error);
    return;
  }

  setUploadedFile(file);
  setImagePreview(URL.createObjectURL(file));
  setIsFromCamera(false);
  setFormError("");
};

export const capturePhotoUtil = (videoRef, stopCamera, setUploadedFile, setImagePreview, setIsFromCamera) => {
  const video = videoRef.current;
  const canvas = document.createElement("canvas");
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(video, 0, 0);
  canvas.toBlob((blob) => {
    const imageUrl = URL.createObjectURL(blob);
    setUploadedFile(blob);
    setImagePreview(imageUrl);
    setIsFromCamera(true);
    stopCamera();
  });
};

export const openCameraUtil = async (videoRef, setCameraMode, setFormError, setCameraStream) => {
  setCameraMode(true);
  setFormError("");
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    videoRef.current.srcObject = stream;
    setCameraStream(stream);
  } catch {
    setFormError("Camera access denied.");
  }
};

export const stopCameraUtil = (cameraStream, setCameraStream, setCameraMode) => {
  if (cameraStream) {
    cameraStream.getTracks().forEach((track) => track.stop());
    setCameraStream(null);
  }
  setCameraMode(false);
};

export const resetPhotoUtil = (setImagePreview, setUploadedFile, setCrop, setZoom, setRotation, setCroppedArea) => {
  setImagePreview(null);
  setUploadedFile(null);
  setCrop({ x: 0, y: 0 });
  setZoom(1);
  setRotation(0);
  setCroppedArea(null);
};
